//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"ExportToggleState",1,0],[0,"ToolMountingJunction",1,"NXObject",0]],[[["r1_tool_tip_junction","r1_tool_tip_tracking_point"],"AskR1ToolTipJunction",{},0,0],[["r1_tool_tip_junction","r1_tool_tip_tracking_point"],"UpdateR1ToolTipJunction",{},2,0],[["tool_tip_junction","tool_tip_tracking_point","tool_tip_radius_id"],"AskToolTipJunction",{},0,0],[["r1_tool_tip_junction","tool_tip_tracking_point","tool_tip_radius_id"],"UpdateToolTipJunction",{},3,0],[["tagArray"],"SetToolCutter",{},1,0],[["numTags","tagArray"],"GetToolCutter",{},0,0],[[],"GetNumToolCutter",{R_:{numTags:''}},0,0],[["tagArray"],"SetToolNonCuttingObjects",{},1,0],[["numTags","tagArray"],"GetToolNonCuttingObjects",{},0,0],[[],"GetNumToolNonCuttingObjects",{R_:{numTags:''}},0,0]],[]];
SPLM.CAM.ManageToolPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ManageToolPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;